import script from "./ButtonBase.vue?vue&type=script&setup=true&lang=ts"
export * from "./ButtonBase.vue?vue&type=script&setup=true&lang=ts"

import "./ButtonBase.vue?vue&type=style&index=0&id=a06a9dc4&scoped=true&lang=css"
import "./ButtonBase.vue?vue&type=style&index=1&id=a06a9dc4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a06a9dc4"]])

export default __exports__